import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { VehicleEntities } from 'client/data/models/vehicle-v2';
import { ExcoVideo } from 'site-modules/shared/components/exco-video/exco-video';
import { getTargeting } from 'site-modules/shared/components/ads-context/ads-context';

const EXCO_ID = 'dd4811f8-d71b-4167-8f77-20be06c87b33'; // placeholder demo id: '073e5784-8789-45e0-a132-61b9999bc9af';

export function ExcoVideoWrapperUI({
  vehicle,
  isMobile,
  pageCategory,
  pageName,
  sessionId,
  visitorId,
  zipCode,
  doNotSell,
  uspString,
  sect1,
  sect2,
  showTestText,
  classes,
  styles,
}) {
  const [targeting, setTargeting] = useState({});
  const excoPropsFromMapStateToProps = {
    mk: get(vehicle, 'make.niceName', ''),
    mdl: get(vehicle, 'model.niceName', ''),
    sub: get(vehicle, 'subModel.niceName', ''),
    year: get(vehicle, 'modelYear.year', ''),
    mobile: isMobile,
    edwcat: pageCategory,
    edwpg: pageName,
    edw: sessionId,
    vid: visitorId,
    zip: zipCode,
    doNotSell,
    usPrivacy: uspString,
    sect1,
    sect2,
  };
  useEffect(() => {
    setTargeting(getTargeting());
  }, [targeting]);

  return (
    <ExcoVideo
      id={EXCO_ID}
      excoProps={excoPropsFromMapStateToProps}
      customTargeting={targeting}
      showTestText={showTestText}
      classes={classes}
      styles={styles}
    />
  );
}
ExcoVideoWrapperUI.propTypes = {
  vehicle: VehicleEntities.MakeModelSubmodelYear,
  isMobile: PropTypes.bool,
  pageName: PropTypes.string,
  pageCategory: PropTypes.string,
  zipCode: PropTypes.string,
  visitorId: PropTypes.string,
  sessionId: PropTypes.string,
  doNotSell: PropTypes.bool,
  uspString: PropTypes.string,
  sect1: PropTypes.string,
  sect2: PropTypes.string,
  showTestText: PropTypes.bool,
  classes: PropTypes.string,
  styles: PropTypes.shape({}),
};

ExcoVideoWrapperUI.defaultProps = {
  vehicle: null,
  isMobile: false,
  pageName: null,
  pageCategory: null,
  zipCode: null,
  visitorId: null,
  sessionId: null,
  doNotSell: false,
  uspString: null,
  sect1: null,
  sect2: null,
  showTestText: true,
  classes: null,
  styles: null,
};

export const mapStateToProps = state => ({
  isMobile: state.mobile,
  pageName: state.pageContext?.page?.name,
  pageCategory: state.pageContext?.page?.category,
  zipCode: state.visitor?.location?.zipCode,
  visitorId: state.visitor?.id,
  sessionId: state.visitor?.session,
  doNotSell: state.visitor?.privacy?.doNotSell,
  uspString: state.visitor?.privacy?.uspString,
  vehicle: state.pageContext?.vehicle,
  sect1: state.pageContext?.page?.adsCustomTargeting?.sect1,
  sect2: state.pageContext?.page?.adsCustomTargeting?.sect2,
});

export const ExcoVideoWrapper = connect(mapStateToProps)(ExcoVideoWrapperUI);
